import CampaignMmmControls from 'features/marketing-mix-modelling/campaign-budget-scenario-planner/campaign-mmm-controls/campaign-mmm-controls';
import MmmCampaignDrillDownOutputTable from 'features/marketing-mix-modelling/campaign-budget-scenario-planner/mmm-campaign-drilldown-output-table';

const CampaignBudgetScenarioPlanner = () => {
  return (
    <>
      <CampaignMmmControls />
      <br />
      <MmmCampaignDrillDownOutputTable />
    </>
  );
};

export default CampaignBudgetScenarioPlanner;
